<template>
  <div class="appBody prh-main bg-grey-light">
    <row-card-component class="zl-page bg-white"
                        typeBlock="zhuanlan" :cardList="cardList">
    </row-card-component>
    <div class="prh-desc px-3 pb-20 bg-white font-13 color-88">
      <div class="jie font-13 line-16 w-100 d-flex justify-content-between px-2 py-3">
        共{{ currentZhuanLan.barNum }}节·已更新{{ currentZhuanLan.updateNum }}节
      </div>
    </div>
    <course-intro-component class="mt-2"></course-intro-component>
    <little-footer class="mb-5r"></little-footer>
    <pay-footer type="zlFoot" :item="currentZhuanLan"></pay-footer>
  </div>
</template>

<script>
  import CourseTop from '@/components/courseTop'
  import CourseIntroComponent from '@/components/courseIntroComponent'
  import payFooter from '@/components/payFooter';
  import CardComponent from '@/components/cardComponent';
  import littleFooter from '@/page/lecturer/components/littleFooter';
  import RowCardComponent from "@/components/rowCardComponent";

  export default {
    name: "zhuanlan",
    components: {
      CardComponent,
      CourseIntroComponent,
      CourseTop,
      payFooter,
      littleFooter,
      RowCardComponent
    },
    data() {
      return {
        type: 'cadv',
        currentZhuanLan: {},
        cardList: [], //需要传array
        zhuanMuluList: []
      }
    },

    mounted() {
      this.getZhuanlan();
    },
    methods: {
      getZhuanlan() {
        this.$store.dispatch('getCourseHome').then((res) => {
          this.currentZhuanLan = res.slice(0, 1)[0];
          this.cardList.push(this.currentZhuanLan);
        })
      }
    }
  }
</script>

<style>

</style>

